module.exports = __webpack_public_path__ + "static/img/DCtu7@2x.70013a5b.png";